import Vue from "vue";

// 1 az全球购 2 火龙购 3 milky Cloud
export var appSource = 3;

// 所需替换的文本 &, 为分隔符，多文案同一替换时用分隔符组合
const replaceTextMap = {
  "https://assets-apk.myazstore.com/store-retail/az_android_app_qqg.apk": {
    2: "https://assets-apk.mkyun.com/store-retail/hhl_android_app_mky.apk",
    3: "https://assets-apk.mkyun.com/store-retail-au/mc_android_app_milkyCloud.apk",
  },
  "https://assets-apk.myazstore.com/store-distributor-new/az_android_app_hht.apk": {
    2: "https://assets-apk.mkyun.com/store-distributor/hhl_android_app_msb.apk",
  },
  // "https://www.mkyun.com/xieyi?id=15": {
  //   2: "https://www.mkyun.com/xieyi?id=15",
  //   3: "https://www.milkycloud.au/xieyi?id=24",
  // },
  // 用户协议
  "id=15": {
    3: "id=24",
  },
  // 隐私政策
  "id=12": {
    3: "id=23",
  },
  ".myaz.com": {
    2: ".mkyun.com",
    3: ".milkycloud.au",
  },
  ".mkyun.com": {
    3: ".milkycloud.au",
  },
  "assets-js.myazstore.com": {
    2: "assets-img.mkyun.com",
    3: "assets-img.milkycloud.au",
  },
  "assets.img.myazstore.com": {
    2: "assets-img.mkyun.com",
    3: "assets-img.milkycloud.au",
  },
  ".myazstore.com": {
    2: ".mkyun.com",
    3: ".milkycloud.au",
  },
  "Myaz.com": {
    2: "Mkyun.com",
    3: "Milkycloud.au",
  },
  "azg公司立足澳新，联动国内，走向世界": {
    2: "杭州火火龙进出口有限公司是一家专注于互联网电子商务领域的公司，特别是服务于海外品牌在中国市场的落地和发展。公司利用自研的M2C智能零售系统，致力于为品牌和渠道提供全链路解决方案，帮助品牌加快传统线下业态与线上电商的融合，提升品牌的渠道渗透率和影响力。",
    3: "MilkyCloud 是一家总部位于澳大利亚的公司，专注于通过在线零售平台提供消费品。我们整合澳大利亚及全球的优质产品资源，通过专业的供应链管理和数字化的用户体验，将高品质的商品送到客户手中。作为一家创新驱动的科技企业，我们专注于利用先进的数字技术赋能跨境电商全链路，致力于为海外品牌提供从市场准入、渠道拓展到数字化运营的全方位解决方案。我们相信，通过科技的力量，能让全球优质商品更便捷地触达消费者，让品牌故事与价值被世界看见，让美好生活触手可及。",
  },
  AZG: {
    2: "妙客云",
    3: "MilkyCloud",
  },
  azg公司: {
    2: "杭州火火龙进出口有限公司",
    3: "MilkyCloud",
  },
  "中国总部:": {
    2: "中国总部:",
    3: "",
  },
  全球好货通全球: {
    2: "智慧赋能渠道，连接全球好品牌",
    3: "甄选全球好物，共享品质生活",
  },
  "甄选品质好货 分享品位生活": {
    2: "让健康与美好生活触手可及",
    3: "让健康与美好生活触手可及",
  },
  "AZ全球购&,az全球购&,全球购&,azg": {
    2: "妙客云",
    3: "MilkyCloud",
  },
  "az好货通&,好货通": {
    2: "妙商宝",
    3: "妙商宝",
  },
  // 购: {
  //   2: "云",
  // },
  通: {
    2: "宝",
    3: "",
  },
  az好货: {
    2: "妙商",
    3: "",
  },
  az全球: {
    2: "妙客",
    3: "",
  },
  az: {
    2: "",
    3: "",
  },
  地推宝: {
    2: "妙推客",
  },
  沈阳金蚁电子商务有限公司: {
    2: "杭州火火龙进出口有限公司",
    3: "CODECREST INTERNATIONAL PTY LTD",
  },
  沈阳金蚁: {
    2: "杭州火火龙",
    3: "",
  },
  // 全球购的appid
  "1544947865": {
    2: "6752891250",
    3: "6762105502",
  },
  // 好货通的appid
  "1531836585": {
    2: "6752891231",
    3: "6752891231",
  },
  "info@alpha-hk.com": {
    2: "info@mkyun.com",
    3: "pay@mycodecrest.com",
  },
  "ICP备案: 辽ICP备2022005380号": {
    2: "ICP备案: 浙ICP备2025154514号",
    3: "",
  },
  "经营许可证编号: 辽B2-20210246": {
    2: "经营许可证编号: 浙B2-2025154514",
    3: "",
  },
  中国杭州市滨江区: {
    2: "中国杭州市滨江区",
    3: "",
  },
  "建业路599号华业发展中心3301-3305室": {
    2: "建业路599号华业发展中心10层1020室",
    3: "2 SOUTHPARK CLOSE, KEYSBOROUGH VIC 3173",
  },
  "@/": {
    1: "",
    2: "assets-hhl/",
    3: "assets-mc/",
  },
  境外授权信息: {
    3: "管理员授权信息",
  },
  授权代表声明书: {
    3: "签约授权书",
  },
  "如有疑问请电话联系客服：0571-86685812": {
    3: "如有疑问请邮箱联系客服：pay@mycodecrest.com",
  },
  境外公司证明: {
    3: "公司证明"
  },
  "审核预计1-3个工作日，结果请关注短信或公众号通知": {
    3: "审核预计1-3个工作日。"
  }
};

function initAppSource() {
  if (window.location.hostname.includes("myaz")) {
    appSource = 1;
  } else if (window.location.hostname.includes("mkyun")) {
    appSource = 2;
  } else if (window.location.hostname.includes("milkycloud")) {
    appSource = 3;
  } else {
    return 3;
  }
}

export function initGlobal() {
  initAppSource();
  Vue.prototype.$G = globalReplace;
  Vue.prototype.$appSource = appSource;
}

export function initLanguage(language) {
  initAppSource();
  return appSource == 1 ? language : "zh";
}

export function configTitle() {
  let title = "";
  if (appSource == 1) {
    title = "azg官网";
  } else if (appSource == 2) {
    title = "妙客云官网";
  } else if (appSource == 3) {
    title = "MilkyCloud";
  } else {
    title = "MilkyCloud";
  }
  document.title = title;
}

// 获取favicon路径
function getFaviconPath() {
  const prefixMap = { 1: "", 2: "hhl-", 3: "mc-" };
  return "/" + prefixMap[appSource] + "favicon.ico";
}

// 动态修改网站图标
export const changeFavicon = () => {
  const iconUrl = getFaviconPath();
  // 检查页面是否已有 favicon 标签
  let link =
    document.querySelector("link[rel*='icon']") ||
    document.createElement("link");
  link.type = "image/x-icon";
  link.rel = "shortcut icon";
  link.href = iconUrl;
  console.log(document.getElementsByTagName("head")[0]);

  // 如果 favicon 标签已经存在，替换它；否则，添加新标签
  document.getElementsByTagName("head")[0].appendChild(link);
  console.log(document.getElementsByTagName("head")[0]);
};

export function $G(string) {
  return globalReplace(string);
}

// export function $src(string) {
//   const result = replaceText(string, "@-/", replaceTextMap["@-/"]);
//   return require(result);
// }

function globalReplace(string) {
  if (string === "@/") {
    return replaceTextMap["@/"][appSource];
  }

  if (appSource === 1) {
    return string;
  }

  // let result = string.toLowerCase();
  let result = string;
  Object.entries(replaceTextMap).some(([key, value]) => {
    let targetString = key;
    if (targetString.includes("&,")) {
      targetString = targetString.split("&,");
    }
    if (typeof targetString === "string") {
      const replaceResult = replaceText(result, targetString, value);
      if (replaceResult != result && replaceResult.includes("https://")) {
        result = replaceResult;
        return true;
      }
      result = replaceResult;
    } else if (Array.isArray(targetString)) {
      targetString.forEach((item) => {
        result = replaceText(result, item, value);
      });
    }
    return false;
  });
  return result;
}

function replaceText(string, key, value) {
  let result = string;
  if (string.includes(key)) {
    const replaceT = value[`${appSource}`];
    if (!replaceT && replaceT != "") {
      return result;
    }
    result = string.split(key).join(replaceT);
  }
  return result;
}
